import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

//Compponent
import DashboardNavigation from '../organisms/DashboardNavigation/DashboardNavigationContainer';
import FacebookConnect from '../organisms/FacebookConnect/FacebookConnectContainer';
import FacebookPages from '../organisms/FacebookPages';

class DashboardFacebook extends Component {
	componentWillMount() {
		this.props.fetchPages();
	}
	renderHandler(pages) { 
		if (pages === undefined) { return false; }

		return (
			<div className="dashboardBody">
				<DashboardNavigation/>
				<div className="dashboardMainContent">
					<div className="container">
					{ pages.length > 0 ? 
						<FacebookPages data={this.props.data.facebookPages} pages={pages}/> 
						: <FacebookConnect data={this.props.data.facebookConnect}/>
					}
					
					</div>
				</div>
			</div>
		)
	}
	render() {
		const pages = this.props.userPages.data; // Reads the store

		return this.renderHandler(pages);
	}
}

export default withRouter(DashboardFacebook);


// WEBPACK FOOTER //
// ./src/redux/components/templates/DashboardFacebook.jsx